import { FC, useState } from 'react';
import { ButtonComponent } from '../../UI/ButtonComponent/ButtonComponent';
import './FilterControlComponent.scss';
import { FilterControlPanelState } from './model';
import { ISortByOption, ScreenType, viewModeType } from '../../../common/view-model';
import SortProductsComponent from '../../sortProducts/SortProductsComponent';
import { useSelector } from 'react-redux';
import { RootState } from '../../../redux/AppReducer';
import { AppActions } from '../../../redux/AppActions';
import { FilterActions } from '../../../redux/FilterActions';
import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../../redux/store';

interface IFilterControlComponentProps {
	showAllFiltersHandler: () => void;
	productsLength: number;
	showAllFiltersButton: boolean;
	showClearAllFiltersButton?: boolean;
	deviceViewMode: viewModeType;
}

const FilterControlComponent: FC<IFilterControlComponentProps> = ({
	showAllFiltersHandler,
	productsLength,
	showAllFiltersButton,
	showClearAllFiltersButton,
	deviceViewMode
}) => {
	const dispatch = useAppDispatch();
	const [state] = useState({ ...FilterControlPanelState });
	const deviceScreen = useSelector((state: RootState) => state.appState.deviceScreen);
	const sortByOptions = useSelector(
		(state: RootState) => state.appState.filterState?.sortByOptions || []
	);
	const searchTerm = useSelector((state: RootState) => state.appState.searchState?.searchTerm);
	const navigate = useNavigate();
	const homePageUrl = 'products';
	const handleModalContent = () =>
		dispatch(
			AppActions.setModalContent({
				content: <></>,
				showCloseIcon: false,
				canScroll: true,
				closeOnDocumentClick: false
			})
		);
	const clearFiltersAndSearch = () => dispatch(FilterActions.clearAllFiltersAndSearchTerm());
	const setSortBy = (sortBy: ISortByOption | undefined) =>
		dispatch(FilterActions.setSortBy(sortBy));

	const handleShowAll = () => {
		if (deviceScreen === ScreenType.TABLET) {
			handleModalContent();
		}
		showAllFiltersHandler();
	};
	const handleClearAll = () => {
		clearFiltersAndSearch();
		navigate(`/${homePageUrl}`);
	};
	return (
		<div
			className={`filter-control-container ${showAllFiltersButton ? 'expanded-wrapper' : ''}${
				searchTerm && deviceScreen === ScreenType.MOBILE ? 'search-wrapper' : ''
			}`}
		>
			{showAllFiltersButton && (
				<ButtonComponent
					style='show-all-filters-btn'
					text={
						deviceViewMode === viewModeType.DESKTOP ? state.showAllFiltersText : state.filtersText
					}
					onClick={handleShowAll}
					icon={<i className='ri-filter-3-line'></i>}
					iconPosition='start'
					id='show-all-filters-btn'
				></ButtonComponent>
			)}
			{deviceScreen !== ScreenType.MOBILE && deviceScreen !== ScreenType.TABLET ? (
				<>
					<span
						className={`items-length ${showAllFiltersButton ? 'length-wrapper' : ''}`}
					>{`${productsLength?.toLocaleString('en-US')} ${state.itemsText}`}</span>
					{showClearAllFiltersButton && (
						<span
							className={`clear-all  ${showAllFiltersButton ? 'length-wrapper' : ''}`}
							onClick={handleClearAll}
						>
							{state.clearAllFiltersText}
						</span>
					)}
				</>
			) : (
				<>
					{showClearAllFiltersButton && (
						<span
							className={`clear-all  ${showAllFiltersButton ? 'length-wrapper' : ''}`}
							onClick={handleClearAll}
						>
							{state.clearAllFiltersText}
						</span>
					)}
					<span
						className={`items-length ${
							showAllFiltersButton ? 'length-wrapper' : ''
						} length-alingment`}
					>{`${productsLength?.toLocaleString('en-US')} ${state.itemsText}`}</span>
				</>
			)}
			<div className='sort-products'>
				<SortProductsComponent
					availableSorts={sortByOptions}
					isFavoritesPage={false}
					setSortBy={setSortBy}
				/>
			</div>
		</div>
	);
};

export default FilterControlComponent;
